import { Star } from "lucide-react";

interface HeroProps {
  onTryFreeClick?: () => void;
}

export function Hero({ onTryFreeClick }: HeroProps) {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-6 text-center">
      <h1 className="text-2xl md:text-5xl font-bold mb-2 leading-tight">
        Create viral shorts{" "}
        <span className="text-orange-500">in seconds with AI</span>
      </h1>
      <p className="text-gray-600 text-lg mb-4 max-w-2xl mx-auto">
        The new way to edit videos. From raw footage to viral shorts in 3
        clicks.
      </p>

      <button
        onClick={onTryFreeClick}
        className="bg-orange-500 hover:bg-orange-600 text-white px-5 py-2 rounded-lg font-semibold text-base mb-6"
      >
        Create Free Shorts
      </button>

      {/* Ratings */}
      {/* <div className="flex justify-center items-center gap-6 flex-wrap mb-8">
        <div className="flex items-center gap-2">
          <div className="flex gap-1">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className="w-4 h-4 fill-orange-500 text-orange-500"
              />
            ))}
          </div>
          <span className="text-sm font-semibold">4.9 out of 5</span>
        </div>
        <p className="text-sm text-gray-600">
          Trusted by over 3 million users
        </p>
      </div> */}

      <div className="max-w-4xl mx-auto">
        <video autoPlay muted loop playsInline className="w-full rounded-2xl">
          <source
            src="https://dqu1p08d61fh.cloudfront.net/static/videos/Header+2025+V9+-+ULTRA+COMP.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </section>
  );
}

